// extracted by css-extract-rspack-plugin
export default {"popoverContent":"l576Tc8tWE46zE_0","headerActions":"e8qt0aNo3VAUMzYS"};